import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { UpdateFlowDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { employeeLegalEntityId } from 'modules/core/lib/employeeLegalEntity'

import { useFetchContractsPermissions } from 'modules/contracts/hooks/useFetchContractsPermissions'
import { useFetchCustomFields } from 'modules/contracts/hooks/useFetchCustomFields'
import { useContractFlow } from 'modules/contracts/lib/contractFlowContext'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import UpdateFlowContent from './_UpdateFlowContent'

const Loading = () => {
  return (
    <Box width="full" height="full" justifyContent="center" alignItems="center">
      <Spinner />
    </Box>
  )
}

const UpdateFlow = () => {
  const { employee, contractVersion, setCustomFields, setCustomValues } = useContractFlow()
  const { company } = useCurrentSession()
  const { data, loading: loadingUpdateFlow } = useQuery(UpdateFlowDocument, {
    variables: { companyId: company.id },
  })
  const { loading: loadingPermissions } = useFetchContractsPermissions(employee)
  const {
    loading: loadingCustomFields,
    resourceFields,
    valuesCollection,
  } = useFetchCustomFields({
    fieldableId: employeeLegalEntityId(employee),
    contractVersion: contractVersion,
    employee,
  })

  useEffect(() => {
    if (!loadingCustomFields) {
      setCustomFields(resourceFields)
      setCustomValues(valuesCollection)
    }
  }, [loadingCustomFields]) // eslint-disable-line react-hooks/exhaustive-deps
  if (loadingPermissions || loadingCustomFields || loadingUpdateFlow) return <Loading />
  const canEdit = policyAuthorizations.for('contracts.edit', employee)
  if (!canEdit) return <NotFound />

  const jobCatalogTreeFeatureEnabled = data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'dev_job_catalog_tree'
  )?.enabled

  return (
    <UpdateFlowContent
      customFields={resourceFields}
      customValues={valuesCollection}
      jobCatalogTrees={data?.jobCatalog?.treesConnection?.nodes}
      jobCatalogTreeFeatureEnabled={jobCatalogTreeFeatureEnabled}
    />
  )
}

export default observer(UpdateFlow)
